/**
 * Mapeo inteligente de nombre de alimento → emoji específico
 * Busca palabras clave en el nombre del alimento para devolver el emoji más apropiado
 */

const FOOD_EMOJI_MAP = [
  // === HUEVOS (prioridad alta - antes de proteínas genéricas) ===
  { keywords: ['huevo', 'clara de huevo', 'huevo entero', 'huevo revuelto', 'huevo cocido', 'huevo duro', 'tortilla de huevo', 'omelette', 'omelet'], emoji: '🥚' },

  // === AVES ===
  { keywords: ['pollo', 'pechuga', 'muslo de pollo', 'ala de pollo', 'gallina'], emoji: '🍗' },
  { keywords: ['pavo', 'turkey'], emoji: '🦃' },

  // === CARNES ROJAS ===
  { keywords: ['carne', 'res', 'bistec', 'filete', 'lomo', 'solomo', 'churrasco', 'ternera', 'cordero'], emoji: '🥩' },
  { keywords: ['cerdo', 'chicharron', 'chuleta'], emoji: '🥩' },
  { keywords: ['tocino', 'tocineta', 'bacon', 'jamon', 'jamón', 'salchicha', 'chorizo', 'embutido'], emoji: '🥓' },

  // === PESCADOS Y MARISCOS ===
  { keywords: ['salmon', 'salmón', 'atun', 'atún', 'tilapia', 'trucha', 'bacalao', 'merluza', 'pescado', 'bagre', 'mojarra', 'sardina', 'robalo'], emoji: '🐟' },
  { keywords: ['camaron', 'camarón', 'langostino', 'marisco', 'pulpo', 'calamar', 'cangrejo'], emoji: '🦐' },

  // === LÁCTEOS ===
  { keywords: ['leche', 'leche entera', 'leche descremada', 'leche deslactosada', 'leche de vaca'], emoji: '🥛' },
  { keywords: ['queso', 'queso crema', 'mozzarella', 'parmesano', 'cottage', 'ricotta', 'cheddar'], emoji: '🧀' },
  { keywords: ['yogur', 'yogurt', 'yoghurt', 'yogur griego'], emoji: '🥛' },
  { keywords: ['mantequilla', 'butter', 'margarina'], emoji: '🧈' },

  // === CEREALES Y GRANOS ===
  { keywords: ['arroz', 'arroz integral', 'arroz blanco', 'arroz basmati'], emoji: '🍚' },
  { keywords: ['avena', 'avena en hojuelas', 'hojuelas', 'oats'], emoji: '🥣' },
  { keywords: ['pan', 'pan integral', 'pan blanco', 'tostada', 'arepa', 'tortilla', 'wrap'], emoji: '🍞' },
  { keywords: ['pasta', 'espagueti', 'macarron', 'fideos', 'lasagna', 'lasaña', 'penne', 'fusilli'], emoji: '🍝' },
  { keywords: ['quinoa', 'quinua', 'cebada', 'centeno', 'trigo', 'granola', 'cereal', 'muesli'], emoji: '🌾' },
  { keywords: ['lenteja', 'frijol', 'garbanzo', 'arveja', 'haba', 'legumbre', 'soya', 'soja'], emoji: '🫘' },

  // === TUBÉRCULOS ===
  { keywords: ['papa', 'patata', 'papa criolla'], emoji: '🥔' },
  { keywords: ['yuca', 'camote', 'batata', 'boniato', 'ñame', 'malanga'], emoji: '🍠' },
  { keywords: ['platano', 'plátano', 'platano verde', 'platano maduro', 'tajada'], emoji: '🍌' },

  // === FRUTAS ===
  { keywords: ['banano', 'banana', 'guineo'], emoji: '🍌' },
  { keywords: ['manzana'], emoji: '🍎' },
  { keywords: ['naranja', 'mandarina', 'clementina', 'tangerina'], emoji: '🍊' },
  { keywords: ['fresa', 'frutilla', 'frambuesa'], emoji: '🍓' },
  { keywords: ['uva', 'uvas'], emoji: '🍇' },
  { keywords: ['piña', 'anana', 'ananá'], emoji: '🍍' },
  { keywords: ['mango'], emoji: '🥭' },
  { keywords: ['sandia', 'sandía', 'patilla'], emoji: '🍉' },
  { keywords: ['durazno', 'melocoton', 'melocotón'], emoji: '🍑' },
  { keywords: ['kiwi'], emoji: '🥝' },
  { keywords: ['cereza'], emoji: '🍒' },
  { keywords: ['limon', 'limón', 'lima'], emoji: '🍋' },
  { keywords: ['aguacate', 'palta', 'avocado'], emoji: '🥑' },
  { keywords: ['coco'], emoji: '🥥' },
  { keywords: ['pera'], emoji: '🍐' },
  { keywords: ['melon', 'melón'], emoji: '🍈' },
  { keywords: ['papaya', 'lechosa'], emoji: '🥭' },
  { keywords: ['mora', 'arandano', 'arándano', 'blueberry', 'berry', 'frutos rojos'], emoji: '🫐' },
  { keywords: ['guayaba', 'guanabana', 'guanábana', 'maracuya', 'maracuyá', 'lulo', 'granadilla', 'curuba', 'tomate de arbol'], emoji: '🍈' },
  { keywords: ['fruta', 'frutas'], emoji: '🍎' },

  // === VERDURAS Y VEGETALES ===
  { keywords: ['brocoli', 'brócoli', 'brocol'], emoji: '🥦' },
  { keywords: ['zanahoria'], emoji: '🥕' },
  { keywords: ['tomate', 'jitomate'], emoji: '🍅' },
  { keywords: ['lechuga', 'ensalada', 'ensalada mixta', 'verde', 'hojas verdes'], emoji: '🥗' },
  { keywords: ['espinaca', 'acelga', 'kale', 'col rizada', 'rucula', 'rúcula'], emoji: '🥬' },
  { keywords: ['pepino', 'pepino cohombro'], emoji: '🥒' },
  { keywords: ['maiz', 'maíz', 'choclo', 'elote', 'mazorca'], emoji: '🌽' },
  { keywords: ['cebolla', 'cebollín', 'puerro'], emoji: '🧅' },
  { keywords: ['ajo'], emoji: '🧄' },
  { keywords: ['pimenton', 'pimentón', 'pimiento', 'chile', 'aji', 'ají'], emoji: '🌶️' },
  { keywords: ['champiñon', 'champiñón', 'hongo', 'seta'], emoji: '🍄' },
  { keywords: ['calabaza', 'calabacin', 'calabacín', 'zucchini', 'auyama', 'ahuyama'], emoji: '🎃' },
  { keywords: ['berenjena'], emoji: '🍆' },
  { keywords: ['apio', 'celery'], emoji: '🥬' },
  { keywords: ['repollo', 'col', 'coliflor'], emoji: '🥬' },
  { keywords: ['remolacha', 'betabel'], emoji: '🟣' },
  { keywords: ['vegetal', 'verdura', 'hortaliza'], emoji: '🥬' },

  // === FRUTOS SECOS Y SEMILLAS ===
  { keywords: ['almendra', 'nuez', 'nueces', 'mani', 'maní', 'cacahuate', 'pistacho', 'marañon', 'marañón', 'avellana', 'fruto seco', 'frutos secos'], emoji: '🥜' },
  { keywords: ['semilla', 'chia', 'chía', 'linaza', 'girasol', 'ajonjoli', 'ajonjolí', 'hemp'], emoji: '🌻' },

  // === ACEITES Y GRASAS ===
  { keywords: ['aceite', 'aceite de oliva', 'aceite de coco', 'oliva'], emoji: '🫒' },
  { keywords: ['crema de mani', 'crema de maní', 'mantequilla de mani', 'mantequilla de maní', 'mantequilla de almendra', 'nut butter'], emoji: '🥜' },

  // === BEBIDAS ===
  { keywords: ['cafe', 'café', 'coffee'], emoji: '☕' },
  { keywords: ['te ', 'té ', 'infusion', 'infusión', 'te verde', 'té verde'], emoji: '🍵' },
  { keywords: ['jugo', 'zumo', 'batido', 'smoothie', 'licuado'], emoji: '🧃' },
  { keywords: ['agua'], emoji: '💧' },

  // === OTROS ===
  { keywords: ['chocolate', 'cacao'], emoji: '🍫' },
  { keywords: ['miel'], emoji: '🍯' },
  { keywords: ['proteina', 'proteína', 'whey', 'protein', 'caseina', 'caseína', 'suero'], emoji: '🥤' },
  { keywords: ['azucar', 'azúcar', 'stevia', 'endulzante', 'edulcorante', 'panela', 'splenda'], emoji: '🍬' },
  { keywords: ['gelatina'], emoji: '🍮' },
  { keywords: ['aceite spray', 'pam', 'spray'], emoji: '🫒' },
  { keywords: ['vinagre', 'salsa', 'mostaza', 'ketchup', 'mayonesa', 'aderezo'], emoji: '🫙' },
];

// Fallback por categoría
const CATEGORY_FALLBACK = {
  'proteinas': '🥩',
  'carbohidratos': '🍚',
  'grasas': '🥑',
  'vegetales': '🥬',
  'frutas': '🍎',
  'lacteos': '🥛',
  'lácteos': '🥛',
  'protein': '🥩',
  'carbs': '🍚',
  'fats': '🥑',
  'vegetables': '🥬',
  'fruits': '🍎',
  'dairy': '🥛',
};

/**
 * Obtiene el emoji más apropiado para un alimento dado
 * @param {string} foodName - Nombre del alimento
 * @param {string} category - Categoría del alimento (fallback)
 * @returns {string} Emoji correspondiente
 */
export function getFoodEmoji(foodName, category) {
  if (!foodName) return CATEGORY_FALLBACK[category] || '🍽️';

  const name = foodName.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  // Find the longest matching keyword for best specificity
  let bestMatch = null;
  let bestLen = 0;
  for (const entry of FOOD_EMOJI_MAP) {
    for (const kw of entry.keywords) {
      const normalizedKw = kw.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      if (name.includes(normalizedKw) && normalizedKw.length > bestLen) {
        bestLen = normalizedKw.length;
        bestMatch = entry.emoji;
      }
    }
  }

  if (bestMatch) return bestMatch;

  // Fallback por categoría
  if (category) {
    return CATEGORY_FALLBACK[category.toLowerCase()] || '🍽️';
  }

  return '🍽️';
}

export default getFoodEmoji;
